<template>
    <a-form-model class="pwd-form" ref="form" :model="form" :rules="rules">
        <a-form-model-item prop="username">
            <a-input v-model="form.username" placeholder="请输入用户名或手机号">
                <icon-user slot="prefix" />
            </a-input>
        </a-form-model-item>
        <a-form-model-item prop="password">
            <a-input-password v-model="form.password" type="password" placeholder="请输入密码">
                <icon-lock slot="prefix" />
            </a-input-password>
        </a-form-model-item>
    </a-form-model>
</template>

<script>
export default {
    data() {
        return {
            form: {
                username: '',
                password: ''
            },
            rules: {
                username: [{ required: true, message: '请输入用户名或手机号', trigger: 'blur' }],
                password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
            }
        };
    },
    methods: {
        validate() {
            return new Promise(res => {
                this.$refs.form.validate(valid => {
                    if (valid) {
                        res(true);
                    } else {
                        res(false);
                    }
                });
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.pwd-form {
    &::v-deep {
        .ant-form-item-control.has-error {
            .ant-input-prefix {
                color: initial;
            }
        }
    }
}
</style>
